export class SignUp {

	// feedBackId: Number;
	firstName: String;
	lastName: String;
	email: String;
    hashPassword: String;
	mobileNum: Number;
 
}